module.exports = __webpack_public_path__ + "static/img/1.47ef480.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/1.png
// module id = 6cRp
// module chunks = 0